import { createContext, useContext } from 'react';
import { useDashboard } from '../hooks/useDashboard';

const DashboardContext = createContext(null);

export const DashboardProvider = ({ children }) => {
  const dashboardData = useDashboard();

  return (
    <DashboardContext.Provider value={dashboardData}>
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboardContext = () => {
  const ctx = useContext(DashboardContext);
  if (!ctx) {
    throw new Error('useDashboardContext must be used within a DashboardProvider');
  }
  return ctx;
};
